//! @ngInject
export function onlyUnique() {
  return (value, index, self) => {
    return self.indexOf(value) === index;
  };
};